// Service Worker Registration
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
);

// Check if we're in production build
// Flag to prevent multiple registrations
let isRegistering = false;
let registrationPromise = null;

export function register(config) {
  // Prevent multiple registrations
  if (isRegistering) {
    return registrationPromise;
  }

  if (!('serviceWorker' in navigator)) {
    return Promise.resolve();
  }

  isRegistering = true;

  // Get the correct service worker URL
  const publicUrl = process.env.PUBLIC_URL || '';
  const swUrl = publicUrl ? `${publicUrl}/service-worker.js` : '/service-worker.js';

  // Register after a short delay to ensure page is fully loaded
  registrationPromise = new Promise((resolve) => {
    if (document.readyState === 'loading') {
      window.addEventListener('load', () => {
        setTimeout(() => {
          if (isLocalhost) {
            checkValidServiceWorker(swUrl, config).then(resolve);
          } else {
            registerValidSW(swUrl, config).then(resolve);
          }
        }, 1000); // Wait 1 second after page load
      });
    } else {
      setTimeout(() => {
        if (isLocalhost) {
          checkValidServiceWorker(swUrl, config).then(resolve);
        } else {
          registerValidSW(swUrl, config).then(resolve);
        }
      }, 1000);
    }
  });

  return registrationPromise;
}

function registerValidSW(swUrl, config) {
  return navigator.serviceWorker
    .register(swUrl, {
      scope: '/',
      updateViaCache: 'none', // Always check for updates
    })
    .then((registration) => {
      console.log('[Service Worker] Registration successful:', swUrl);
      
      // Don't check for updates immediately - wait to avoid loops
      // Check for updates after 30 seconds (only once)
      let updateChecked = false;
      setTimeout(() => {
        if (!updateChecked) {
          updateChecked = true;
          registration.update();
        }
      }, 30000); // Wait 30 seconds before first update check

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // New content available - but don't auto-refresh
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // Content cached for the first time
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };

      // Periodic update check (every hour) - only in production
      if (process.env.NODE_ENV === 'production') {
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000);
      }

      return registration;
    })
    .catch((error) => {
      if (config && config.onError) {
        config.onError(error);
      }
      throw error;
    });
}

function checkValidServiceWorker(swUrl, config) {
  // Check if service worker file exists first, then register
  return fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
    cache: 'no-cache',
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // Don't register if file is invalid
        return Promise.resolve();
      } else {
        // Register only if file is valid
        return registerValidSW(swUrl, config);
      }
    })
    .catch((error) => {
      // In localhost, try to register anyway (might work)
      return registerValidSW(swUrl, config);
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => {
        registrations.forEach((registration) => registration.unregister());
      })
      .catch(() => {
        // Error handled silently
      });
  }
}

